import React from 'react';
import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';

type Props = { rows: any[]; loading?: boolean };

class ForecastVariableGrid extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'variablecode', headerName: 'Code', width: 150 },
    { field: 'variablename', headerName: 'Variable', flex: 1, minWidth: 260 },
    { field: 'datasetcode', headerName: 'Dataset', width: 140 },
    { field: 'forecastmethod', headerName: 'Forecast Method', width: 190 },
    { field: 'source', headerName: 'Current Source', width: 190 },
    { field: 'required', headerName: 'Required', width: 120, renderCell: (p) => <Chip size="small" label={p.value ? 'Yes' : 'No'} color={p.value ? 'success' : 'default'} /> },
    { field: 'forecastable', headerName: 'Forecastable', width: 130, renderCell: (p) => <Chip size="small" label={p.value ? 'Yes' : 'No'} color={p.value ? 'info' : 'warning'} /> },
    { field: 'effectivefrom', headerName: 'From', width: 120 },
    { field: 'effectiveto', headerName: 'To', width: 120 },
    { field: 'status', headerName: 'Status', width: 120 },
  ];

  getRowId = (row: any) => row.id || row.rid || row.variablecode;

  render() {
    return (
      <FDataGrid title="Forecast Variable Registry" subtitle="Configurable variables earmarked for forecasting, management estimates or fixed assumptions." rows={this.props.rows || []} columns={this.columns} loading={this.props.loading} height={460} showQuickFilter toolbarSx={{ backgroundColor: '#e7f6ea' }} getRowId={this.getRowId} pageSizeOptions={[10, 25, 50]} />
    );
  }
}

export default ForecastVariableGrid;
